import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { IntlProvider } from 'react-intl';

import getLocale from 'services/localeFactory';

import amarc21 from '@amarc21/locales';
import lbsi from '@lbsi/locales';
import remax_at from '@remax-at/locales';
import remax_it from '@remax-it/locales';
import remax_de from '@remax-de/locales';
import remax_ro from '@remax-ro/locales';
import propnow from '@propnow/locales';
import propnowDevelopments from '@propnow-developments/locales';
import generic from 'locales';

//const locales = require(`../../@${process.env.REACT_APP_TENANT}/locales`);

const withIntl = (WrappedComponent) => {
  class IntlWrapper extends Component {
    render() {
      let { locale } = this.props;

      var specific = {};

      switch (process.env.REACT_APP_TENANT) {
        case 'amarc21':
          specific = amarc21;
          break;
        case 'lbsi':
          specific = lbsi;
          break;
        case 'remax-at':
          specific = remax_at;
          break;
        case 'remax-it':
          specific = remax_it;
          break;
        case 'remax-de':
          specific = remax_de;
          break;
        case 'remax-ro':
          specific = remax_ro;
          break;
        case 'propnow':
          specific = propnow;
          break;
        case 'propnow-developments':
          specific = propnowDevelopments;
          break;
        default:
          break;
      }

      var localeSet = getLocale(locale, specific.invariant, generic, specific);

      return (
        <IntlProvider
          locale={locale}
          messages={localeSet.messages}
          onError={() => {}}
        >
          <WrappedComponent {...this.props} />
        </IntlProvider>
      );
    }
  }

  return observer(IntlWrapper);
};

export default withIntl;



// WEBPACK FOOTER //
// ./src/app/components/IntlWrapper/index.jsx